import React from "react";
import { Avatar, Stack, Typography, useTheme } from "@mui/material";

interface UserMenuHeaderProps {
  profileImage?: string;
  userName: string;
}

const UserMenuHeader = ({ profileImage, userName }: UserMenuHeaderProps) => {
  const theme = useTheme();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        bgcolor: theme.palette.primary.light,
        pt: 2,
        pb: 1,
        position: "relative",
        height: 56,
        bottom: 10,
      }}
    >
      <Avatar
        src={profileImage || ""}
        sx={{
          width: 56,
          height: 56,
          bgcolor: theme.palette.common.white,
          color: theme.palette.primary.dark,
          border: 1,
          borderColor: theme.palette.primary.dark,
          position: "absolute",
          top: "85%",
          transform: "translateY(-50%)",
        }}
      >
        {!profileImage &&
          `${userName[0] || ""}${userName.split(" ")[1]?.[0] || ""}`.trim()}
      </Avatar>

      <Stack sx={{ height: 40, mt: 8 }} />
      <Typography
        sx={{ mt: 10, color: theme.palette.common.black, fontWeight: 600 }}
      >
        {userName}
      </Typography>
    </Stack>
  );
};

export { UserMenuHeader };
